export function getUserAccess(user, projectUid, contacts) {
  if (user.uid === projectUid) {
    return {
      readOnly: false,
      allowCreate: true,
      allowUpdate: true,
      allowDelete: true,
    };
  }
  
  //determine access based on contact list
  const contact = contacts.find((c) => c.Email === user.email);
  if (contact === undefined) {
    return {
      readOnly: true,
      allowCreate: false,
      allowUpdate: false,
      allowDelete: false,
    };
  } else if (
    contact["Collaboration Status"] ===
    "Read Only (No Update, Create, or Delete)"
  ) {
    return {
      readOnly: true,
      allowCreate: false,
      allowUpdate: false,
      allowDelete: false,
    };
  } else if (
    contact["Collaboration Status"] ===
    "Read and Update Only (No Create or Delete)"
  ) {
    return {
      readOnly: false,
      allowCreate: false,
      allowUpdate: true,
      allowDelete: false,
    };
  } else if (
    contact["Collaboration Status"] ===
    "Read, Update, and Create Only (No Delete)"
  ) {
    return {
      readOnly: false,
      allowCreate: true,
      allowUpdate: true,
      allowDelete: false,
    };
  } else if (
    contact["Collaboration Status"] === "Full Control (unlimited access)"
  ) {
    return {
      readOnly: false,
      allowCreate: true,
      allowUpdate: true,
      allowDelete: true,
    };
  } else {
    return {
      readOnly: true,
      allowCreate: false,
      allowUpdate: false,
      allowDelete: false,
    };
  }
}
